export default __webpack_public_path__ + "static/media/KneeFlexionAtMidswing.1577fa92.png";